import { css } from '@emotion/react';

export const formSelectContainer = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
`;

export const formSelectOption = css`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const formSelectLine2 = css`
  font-size: 12px;
  font-weight: 400;
`;

export const formSelectOptionIcon = css`
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
